import type {
  CreateImportResponse,
  GetImportResponse,
  UploadImportImageResponse,
} from '../types/import';
import { apiRequest } from './apiClient';

export async function uploadImportImage(imageData: string): Promise<UploadImportImageResponse> {
  return apiRequest<UploadImportImageResponse>('/upload/import-image', {
    method: 'POST',
    body: JSON.stringify({ imageData }),
  });
}

export async function startImport(imageKeys: string[], accountId?: string): Promise<CreateImportResponse> {
  return apiRequest<CreateImportResponse>('/imports', {
    method: 'POST',
    body: JSON.stringify({
      imageKeys,
      ...(accountId ? { accountId } : {}),
    }),
  });
}

export async function getImport(importId: string): Promise<GetImportResponse> {
  return apiRequest<GetImportResponse>(`/imports/${importId}`, {
    method: 'GET',
  });
}
